import { performReverseGeocode } from './distributor-reverse-geocode';
import { findDistributors } from './distributor-find';
import { getGoogleAPILanguageCode } from './distributor-language';
import { DistributorMap } from './DistributorMap';

/**
 * Handle the 0th search. (Will be triggered when the user allows access to their coordinates).
 */
export const handleDistributorZeroSearch = async (
  map: DistributorMap,
  coordinates: GeolocationCoordinates,
) => {
  const addressFormElement = document.querySelector<HTMLInputElement>(
    '#distributor-search-filter input[type=text]',
  )!!;

  const isAddressFormElementEmpty = () => addressFormElement.value.length === 0;

  if (!isAddressFormElementEmpty()) return;

  const formElement = document.getElementById('distributor-search-filter')!!;
  const apiKey = formElement.dataset['key']!!;
  const apiUrl = formElement.dataset['url']!!;
  const distanceUnit = formElement.dataset['distanceUnit']!! || 'km';
  const initialPartnerFilter =
    formElement.dataset['initialPartnerFilter']!! || '';

  const geoCoords = new window.google.maps.LatLng(
    coordinates.latitude,
    coordinates.longitude,
  );
  const [geocodingResponse, distributors] = await Promise.all([
    performReverseGeocode(apiKey, geoCoords, getGoogleAPILanguageCode()),
    findDistributors(
      apiUrl,
      initialPartnerFilter,
      '25',
      distanceUnit,
      geoCoords,
      '',
    ),
  ]);

  if (!isAddressFormElementEmpty()) return;

  map.setLastAddressQuery(`${coordinates.latitude},${coordinates.longitude}`);

  const geocodingResult = geocodingResponse.results[0];

  if (geocodingResponse.status === 'OK' && geocodingResult !== undefined) {
    addressFormElement.value = geocodingResult.formatted_address;
  } else if (geocodingResponse.status === 'ZERO_RESULTS') {
    addressFormElement.value = `${coordinates.latitude}:${coordinates.longitude}`;
  }

  map.loadLocations(
    distributors,
    geocodingResult?.formatted_address,
    geocodingResult?.geometry.location ??
      new window.google.maps.LatLng(
        coordinates.latitude,
        coordinates.longitude,
      ),
  );
};
